import React, { Fragment } from 'react';
import '../TeamMembers/TeamMemberByOneBy.css';
import pht from '../imageproje/107-1/00.avif'
import CardMedia from '@mui/material/CardMedia';
import {Outlet} from 'react-router-dom';
import AliMetinPhoto from '../imageproje/TeamImage/AliMetin.avif';
import { Container, Grid, Typography } from '@mui/material';
import Comunication from '../components/Comunication';
import ComunicationPhone from '../components/ComunicationPhone';
import ComunicationEmail from '../components/ComunicationEmail';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

function AliMetin() {
  return (
    <Fragment>
      <Comunication/>
      <ComunicationPhone/>
      <ComunicationEmail/>
      <Container style={{marginTop:100, padding:0}}>
        
        <CardMedia 
        sx={{width:'100%'}}
        image={pht}>
        <p className='writingPosition'>Ali Metin</p>
        </CardMedia>
        
      </Container>
      <Container>
        <Grid className='teamMemberDeatilInfo' sx={{display:'flex'}}>
          <Grid size={6}>
            <img className='teamMember-Photo' src={AliMetinPhoto} style={{width:350,height:'auto'}} alt="" />
          </Grid>
          <Grid size={6} sx={{marginLeft:5}}>
            <Typography variant='body1' component='p'><br />
              Ali Metin, 2005 itibari ile Emlak ve İnşaat sektöründe çalışıyor. 2022 itibari ile Emlakçın'nin 1 numaralı satış temsilcisidir. Ulaşılabilir, bilgili ve güvenilirdir.
              <br />
              <br />
            </Typography>
            <Typography variant='h5' component='h5'>
              <i>20 yıl inşaat ve emlak piyasa deneyimine sahip</i> 
              <br />
              <br />
            </Typography>
            <Typography variant='body1' component='p'>
              Profesyonellerle dolu gayrimenkul pazarında, gerçekten sıra dışı bir performans sergileyen biri olarak kendini kanıtladı.
              <br />
              <br />
              Başarıları, bölgesindeki 20 yılı aşkın gayrimenkul deneyiminin doğrudan bir yansımasıdır.
              <br />
              <br />
              Çatalca'da doğdu, 2004'te inşaat mühendislik diplomasını aldı, 2004-2022 yılları arasında büyük inşaat ve danışmanlık şirkelerinde çalıştı, 2004 yılı itibari ile inşaat sektör deneyimlerinden sonra, 2015'te inşaat şirketini ve daha sonra 2022'da Emlakçın'ı kurdu.
              <br />
            </Typography> 
          </Grid>
        </Grid >
          <Grid size={12}>
            <Typography variant='body1' component='p'>
              <br />
              Yurt dışı, içi büyük şirket ve projelerde çalıştı. Sıra dışı üniversite, stadyum, buz hokeyi, alışveriş merkesi, yaşam konsep projeleri ve hotel projeleri yaptı. Uygulama ve proje yönetim safhalarını yönetti. Gerçek anlamada kariyeri gayrimenkul sektörü ile gelişti.
              <br />
              <br />
              Gayrimenkul satışı ve listelemesinin yanı sıra gayrimenkul geliştirme alanında da kapsamlı deneyime sahiptir.
              Son projeleri arasında yerel bir market kompleksinin içinde ve çevresinde ticari ve konut amaçlı mülklerin bir karışımının geliştirilmesi yer alıyor.
              istanbulun en yeni mahallelerinden bazılarında spekülatif evlerin tasarımı, inşası ve satışı da yer alıyor.
              <br />
              <br />
            </Typography>
          </Grid>
        <Grid>
        </Grid>   
          <Typography variant='body1' component='p'> 
            İstanbul topluluğunun kendini adamış bir üyesi olan Ali, şehirde ve çevresinde çok sayıda kâr amacı gütmeyen kuruluşta görev yaptı.
            <br/>
            <br/>
            Uzun zamandır evim dediği şehre duyduğu coşku ve mütevazı ulaşılabilirliği, onu şehirde bir emlakçı için ideal seçim haline getiriyor.
            Kanıtlanmış başarı geçmişi onu gayrimenkul deneyiminin kıstası haline getiriyor; bugün sizi istıranca dağları cennetine bağlamasına izin verin.
            <br />
            <br />

          </Typography>
        </Container>
        <Container className='teamMember-Personel-Info'  sx={{marginBottom:5}} >
          <Grid className='teamMemberSocialMedia' sx={{display:'flex'}} gap={2}>
            <Grid  size={2}>
              <a href="https://www.youtube.com/@emlakcinn" className='teamMenberOneByOne'><YouTubeIcon/></a>
            </Grid>
            <Grid size={2}  >
              <a href="https://www.facebook.com/share/1BBqDbdAdU/?mibextid=LQQJ4d" className='teamMenberOneByOne'><FacebookIcon/></a>
            </Grid>
            <Grid size={2}  >
              <a href="https://www.instagram.com/emlakcinn" className='teamMenberOneByOne'><InstagramIcon/></a>
            </Grid>
            <Grid size={2}>
              <a href="https://x.com/emlakcinn" className='teamMenberOneByOne'><TwitterIcon/></a>
            </Grid>
            <Grid size={2}>
              <a href="https://api.whatsapp.com/send?phone=905322005989"className='teamMenberOneByOne'><WhatsAppIcon/></a>
            </Grid>
            <Grid size={2}>
              <a href="tel:+905322005989"className='teamMenberOneByOne'><PhoneIcon/></a>
            </Grid>
            <Grid size={2}>
              <a href="mailto:info@emlakcinn.com"className='teamMenberOneByOne'><MailOutlineIcon/></a>
            </Grid>
          </Grid>
        </Container>
        <Container className='teamMember-Personel-Info' sx={{backgroundColor:'rgb(241, 241, 241)',marginBottom:5,padding:3}}>
          <Grid >
            <Grid size={12}>
              <Typography variant='h5' component='h5'><i>Ali Metin</i></Typography>
            </Grid>
            <Grid size={12}>
            <Typography variant='h5' component='h5' className='realEstateInfo' >Emlak Danışmanı</Typography>
            <br />
            </Grid>
          </Grid>
          <Grid sx={{display:'flex'}} gap={15}>
            <Grid size={4}>
            <Typography>Telefon</Typography>
              <Typography>
                0 532 200 59 89
              </Typography>
            </Grid>
            <Grid size={4}>
              <Typography>Email</Typography>
              <Typography>
                ali.metin@emlakcinn.com
              </Typography>
            </Grid>
            <Grid size={4}>
              <Typography>Adres</Typography>
              <Typography>
                Cebeci Mah, 2457 Sok, No: 23/B Sultangazi / İstanbul
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Outlet/>
    </Fragment>
  )
}

export default AliMetin;